import React from "react";
import CombinedInspectionWizard from "./CombinedInspectionWizard";
import InspectionWizard from "./InspectionWizard";

export default function InspectionWizardController({
  isOpen,
  building,
  onClose,
  refreshList,
}) {
  // Simple pass-through to the new combined component
  if (!isOpen) return null;

  return (
    // <CombinedInspectionWizard
    //   building={building}
    //   onClose={onClose}
    //   refreshList={refreshList}
    // />
    <InspectionWizard
      isOpen={isOpen}
      building={building}
      onClose={onClose}
      refreshList={refreshList}
    />
  );
}
